var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / AU") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2E3B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC0D1B",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-AU",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Mask-Copy",
    fill: "#0A17A7",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2968145,-0.578591639 C12.4289261,0.574083174 12.1796848,0.947954902 11.9158002,1.1364439 L11.9158002,1.1364439 L7.66666667,4.1715393 L7.66666667,5.18002169 L15.1566841,11.6000366 L6.57256028,6.33333333 L5.42893208,6.33333333 L-0.333333333,9.93474921 L-0.333333333,8.49512737 L4.33333333,5.16179403 L4.33333333,4.15331164 L-0.901085803,-0.333333333 L0.773488351,-0.333333333 L5.44015502,3 L6.57106792,3 Z",
    id: "Rectangle-36",
    stroke: "#FFFFFF",
    strokeWidth: 0.666666667,
    fill: "#FF2E3B",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,3.33333333 L0,6 L4.66666667,6 L4.66666667,9.33948135 C4.66666667,9.70427573 4.97256724,10 5.33957926,10 L6.66042074,10 C7.0320601,10 7.33333333,9.69934988 7.33333333,9.33948135 L7.33333333,6 L11.9911963,6 C12.3642483,6 12.6666667,5.69409943 12.6666667,5.3270874 L12.6666667,4.00624593 C12.6666667,3.63460657 12.3646425,3.33333333 11.9911963,3.33333333 L7.33333333,3.33333333 L7.33333333,0 L4.66666667,0 L4.66666667,3.33333333 L0,3.33333333 Z",
    id: "Rectangle-2",
    fill: "url(#linearGradient-3)",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-36",
    fill: "url(#linearGradient-4)",
    mask: "url(#mask-2)",
    points: "0 4 5.33333333 4 5.33333333 3.33333333 5.33333333 0 6.66666667 0 6.66666667 3.33333333 6.66666667 4 12 4 12 5.33333333 6.66666667 5.33333333 6.66666667 6 6.66666667 9.33333333 5.33333333 9.33333333 5.33333333 6 5.33333333 5.33333333 0 5.33333333"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-2",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "6 16.3333333 4.8244295 16.9513673 5.04894348 15.6423503 4.09788697 14.7152993 5.41221475 14.5243163 6 13.3333333 6.58778525 14.5243163 7.90211303 14.7152993 6.95105652 15.6423503 7.1755705 16.9513673"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-2",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "20 17.3333333 19.057191 17.6094757 19.3333333 16.6666667 19.057191 15.7238576 20 16 20.942809 15.7238576 20.6666667 16.6666667 20.942809 17.6094757"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-2",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "20 4.66666667 19.057191 4.94280904 19.3333333 4 19.057191 3.05719096 20 3.33333333 20.942809 3.05719096 20.6666667 4 20.942809 4.94280904"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-2",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "24 8.66666667 23.057191 8.94280904 23.3333333 8 23.057191 7.05719096 24 7.33333333 24.942809 7.05719096 24.6666667 8 24.942809 8.94280904"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-2",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "16 10 15.057191 10.2761424 15.3333333 9.33333333 15.057191 8.39052429 16 8.66666667 16.942809 8.39052429 16.6666667 9.33333333 16.942809 10.2761424"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-2",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "22 11.6666667 21.5285955 11.8047379 21.6666667 11.3333333 21.5285955 10.8619288 22 11 22.4714045 10.8619288 22.3333333 11.3333333 22.4714045 11.8047379"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAu);
export default __webpack_public_path__ + "static/media/AU.c76226bcebc580b66e6866b1d264c9fe.svg";
export { ForwardRef as ReactComponent };